import { render, staticRenderFns } from "./across_recommend.vue?vue&type=template&id=6c5145a6"
import script from "./across_recommend.vue?vue&type=script&lang=ts"
export * from "./across_recommend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports